import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Description from './Description';

const TitleContainer = ({ title, description }) => {
    return (
        <Typography variant="h6" component="h6">
            {title}
            {description && <Description>{description}</Description>}
        </Typography>
    );
};

TitleContainer.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
};

export default TitleContainer;
